import { z, uuidSchema } from '@kc3/validation';
export const CreateSkillRequestSchema = z.object({
    status: z.boolean().optional(),
    name: z.string().min(1).max(100),
    description: z.string().max(500).optional(),
    category: z.string().min(1).max(50).optional(),
    color: z.string().regex(/^#[0-9A-Fa-f]{6}$/).optional(),
    teamIds: z.array(uuidSchema).optional(),
    campaignType: z.string().min(1).max(50).optional(),
    campaignId: uuidSchema.optional(),
    searchOption: z.boolean().optional(),
    userIds: z.array(uuidSchema).optional(),
});
export const UpdateSkillRequestSchema = z
    .object({
    status: z.boolean().optional(),
    name: z.string().min(1).max(100).optional(),
    description: z.string().max(500).optional(),
    category: z.string().min(1).max(50).optional(),
    color: z.string().regex(/^#[0-9A-Fa-f]{6}$/).optional(),
    teamIds: z.array(uuidSchema).optional(),
    campaignType: z.string().min(1).max(50).optional(),
    campaignId: uuidSchema.optional(),
    searchOption: z.boolean().optional(),
    userIds: z.array(uuidSchema).optional(),
})
    .refine((v) => Object.values(v).some((x) => x !== undefined), {
    message: 'At least one field must be provided',
});
export const SkillResponseSchema = z.object({
    id: uuidSchema,
    status: z.boolean(),
    name: z.string(),
    description: z.string().nullable(),
    category: z.string().nullable(),
    color: z.string().nullable(),
    teamIds: z.array(uuidSchema).optional(),
    campaignType: z.string().nullable(),
    campaignId: uuidSchema.nullable(),
    searchOption: z.boolean(),
    userIds: z.array(uuidSchema).optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
export const ListSkillsQuerySchema = z.object({
    includeDeleted: z
        .string()
        .optional()
        .transform((v) => v === 'true'),
    category: z.string().optional(),
    search: z.string().optional(),
});
export const SkillReferencedErrorSchema = z.object({
    error: z.literal('SKILL_IN_USE'),
    message: z.string(),
    agentCount: z.number().int(),
    queueCount: z.number().int(),
});
//# sourceMappingURL=skills.js.map